import BookItem from "./book-item.component";

export default BookItem;
